<!--公共底部-->
<template>
    <div class="" v-html="programaSetInfo?programaSetInfo.footer_html:''">
        <!-- <p>电话: 010-5795-2000</p>
        <p>地址 : 北京市海淀区中关村丹棱街3号 中国电子大厦B座15层</p>
        <p>Copy @ 2001-2004 京ICP备19003293号-1 京公网安备11010802030197 电信业务经营许可证号：京B2-20191655</p>
        <p><a href="https://www.bailitop.com/about_us/20190701/6185.html" target="_blank">京网文 [2017] 6419-727 号</a></p> -->
    </div>
</template>

<script>
    import pageUtils from '@/js/page/pageUtil.js';
    import utils from '@/js/utils/util.js';
    export default {
        name: 'examinationFooter',
        data() {
            return {
                programaSetInfo:null,
            };
        },
        created() {
            var programaSetInfo = pageUtils.getSessionParam("programaSetInfo");
            if(programaSetInfo) {
                this.programaSetInfo = JSON.parse(programaSetInfo);
            }
        },
        mounted() {

        },
        methods: {
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
